import React from 'react';
import {StyleSheet, View} from 'react-native';
import {commonStyles} from '../../../../styles/ConstantStyles';
import VehicleCard from '../../../trip/components/vehicle-card/VehicleCard.component';
import SelectVehicleCard from '../../../trip/select/components/select-vehicle-card/SelectVehicleCard.component';
import Plaque from '../../../trip/components/plaque/Plaque.component';
import CircleBattery from '../../../trip/select/components/circle-battery/CircleBattery.component';
import DamagedVehicleCard from './damaged-vehicle-card/DamagedVehicleCard.component';

export const VehicleDetail = props => {
  const {item, hasReadyLabel, hasIcon} = props;
  return (
    <DamagedVehicleCard
      hasReadyLabel={hasReadyLabel}
      hasIcon
      leftChildren={
        <CircleBattery
          screen={'damageList'}
          value={item?.battery}
          iconWidth={32}
          iconHeight={32}
        />
      }
      containerStyle={styles.container}
      {...props}>
      <Plaque value={item?.plaque} containerStyle={styles.plaque} />
    </DamagedVehicleCard>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 72,
    overflow: 'hidden',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#EAEAEA',
    ...commonStyles.rowCenterBetween,
  },
  container: {
    paddingLeft: 0,
  },
  plaque: {marginTop: 2},
  battery: {
    marginRight: -5.83,
  },
});
